import React from 'react'
import Dropdown, { DropdownTrigger, DropdownContent } from 'react-simple-dropdown'
import { ChevronDown } from 'react-feather'
import { changeLanguage } from '../../features/system/slice'
import { useDispatch, useSelector } from 'react-redux'
import './header-dropdown.css';

const LanguageDropdown = () => {
  const dispatch = useDispatch()
  const language = useSelector(state => state.system.language)
  const languageName = language.name
  const flag = languageName === 'en' ? 'australia' : 'indonesia'

  return (
    <React.Fragment>
      <Dropdown>
        <DropdownTrigger>
          <div className="flex items-center cursor-pointer ml-8">
            <div
              style={{backgroundImage: `url('/images/flags/khub_${flag}.svg')`, height: '15px', width: '20px', backgroundSize: '100%', backgroundColor: '#f8f8f8'}}
              className="bg-no-repeat bg-center mr-2 shadow"
            />
            <ChevronDown style={{width: '18px'}}/>
          </div>
        </DropdownTrigger>
        <DropdownContent className="language-dropdown-content">
          <div>
            <ul className="p-5 font-primary normal-case font-normal border-b" style={{borderColor: '#eee'}}>
              <li className="mb-2">
                <div className="cursor-pointer text-sm" onClick={() => dispatch(changeLanguage('en'))}>
                  {language.name === 'en' ? 'English' : 'Bahasa Inggris'}
                </div>
              </li>
              <li className="">
                <div className="cursor-pointer text-sm" onClick={() => dispatch(changeLanguage('id'))}>
                  {language.name === 'en' ? 'Indonesia' : 'Bahasa Indonesia'}
                </div>
              </li>
            </ul>
          </div>
        </DropdownContent>
      </Dropdown>
    </React.Fragment>
  )
}

export { LanguageDropdown }
